import { render, staticRenderFns } from "./change-device-next.vue?vue&type=template&id=1fd6f8f4&"
import script from "./change-device-next.vue?vue&type=script&lang=js&"
export * from "./change-device-next.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports